import TagManager from 'react-gtm-module';
import clssConfig from 'Config';

export const initializeTagManager = () => {
  const { gtmId } = clssConfig;
  if (!gtmId) {
    return;
  }
  const tagManagerArgs = { gtmId };
  TagManager.initialize(tagManagerArgs);
};

export const addDataLayer = (dataLayer) => {
  const { gtmId } = clssConfig;
  if (!dataLayer || !gtmId) {
    return;
  }

  const dl = {
    dataLayer: {
      event: 'specsaversEvent',
      category: 'Contact Lens Subscriptions',
      ...dataLayer,
    },
  };
  TagManager.dataLayer(dl);
};
